import React, { createContext, useContext } from 'react';
import DOMPurify from 'dompurify';

const SecurityContext = createContext(null);

export const useSecurity = () => {
  const context = useContext(SecurityContext);
  if (!context) throw new Error('useSecurity must be used within SecurityProvider');
  return context;
};

export const SecurityProvider = ({ children }) => {
  const sanitizeInput = (input) => DOMPurify.sanitize(input);
  
  const validateFile = (file) => {
    const maxSize = 10 * 1024 * 1024 * 1024; // 10 Go
    const allowedExtensions = ['.csv', '.xlsx', '.xls', '.json', '.sas7bdat', '.rds', '.rda', '.rdata'];
    
    console.log('Validating file:', file.name);
    
    if (file.size > maxSize) {
      return { valid: false, error: 'File size exceeds 10 Go limit' };
    }
    
    const extension = '.' + file.name.split('.').pop()?.toLowerCase();
    if (!allowedExtensions.includes(extension)) {
      return { valid: false, error: `Invalid file type. Allowed: ${allowedExtensions.join(', ')}` };
    }
    
    return { valid: true };
  };

  return (
    <SecurityContext.Provider value={{ sanitizeInput, validateFile }}>
      {children}
    </SecurityContext.Provider>
  );
};
